import React from 'react';

import styles from 'prototypes/securedCard/app.module.scss';
import { formatMoney } from 'prototypes/securedCard/formatMoney';
import {
  PAYCHECK_MAX_CENTS,
  PAYCHECK_MIN_CENTS,
  PAYCHECK_PRESETS_CENTS,
  PAYCHECK_STEP_CENTS,
} from 'prototypes/securedCard/prototypeAssumptions';
import { cadenceLabel } from 'prototypes/securedCard/storyMath';
import { PayCadence } from 'prototypes/securedCard/types';

interface PaycheckControlProps {
  cents: number;
  cadence: PayCadence;
  idPrefix: string;
  onCents: (cents: number) => void;
  onCadence: (cadence: PayCadence) => void;
}

const PaycheckControl = ({ cents, cadence, idPrefix, onCents, onCadence }: PaycheckControlProps) => (
  <div className={styles.field}>
    <p className={styles.fieldLabel}>From each paycheck</p>
    <p className={styles.depositAmount}>{formatMoney(cents)}</p>
    <label className={styles.notice} htmlFor={`${idPrefix}-amount`}>
      Payroll deduction
    </label>
    <input
      id={`${idPrefix}-amount`}
      className={styles.slider}
      type="range"
      min={PAYCHECK_MIN_CENTS}
      max={PAYCHECK_MAX_CENTS}
      step={PAYCHECK_STEP_CENTS}
      value={cents}
      onChange={(event) => onCents(Number(event.target.value))}
    />
    <div className={styles.sliderScale}>
      <span>{formatMoney(PAYCHECK_MIN_CENTS)}</span>
      <span>{formatMoney(PAYCHECK_MAX_CENTS)}</span>
    </div>
    <div className={styles.presets}>
      {PAYCHECK_PRESETS_CENTS.map((preset) => (
        <button
          key={preset}
          type="button"
          className={cents === preset ? `${styles.preset} ${styles.presetOn}` : styles.preset}
          aria-pressed={cents === preset}
          onClick={() => onCents(preset)}
        >
          {formatMoney(preset)}
        </button>
      ))}
    </div>
    <div className={styles.presets} role="group" aria-label="How often you get paid">
      {Object.values(PayCadence).map((item) => (
        <button
          key={item}
          type="button"
          className={cadence === item ? `${styles.preset} ${styles.presetOn}` : styles.preset}
          aria-pressed={cadence === item}
          onClick={() => onCadence(item)}
        >
          {cadenceLabel(item)}
        </button>
      ))}
    </div>
  </div>
);

export default PaycheckControl;
